import { Injectable, Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { MarketdateComment } from './marketdate-comment.model';
import { MarketdateCommentService } from './marketdate-comment.service';
@Injectable()
export class MarketdateCommentPopupService {
    private isOpen = false;
    constructor(
        private datePipe: DatePipe,
        private modalService: NgbModal,
        private router: Router,
        private marketdateCommentService: MarketdateCommentService

    ) {}

    open(component: Component, id?: number | any): NgbModalRef {
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;

        if (id) {
            this.marketdateCommentService.find(id).subscribe((marketdateComment) => {
                marketdateComment.updated = this.datePipe
                    .transform(marketdateComment.updated, 'yyyy-MM-ddThh:mm');
                marketdateComment.created = this.datePipe
                    .transform(marketdateComment.created, 'yyyy-MM-ddThh:mm');
                this.marketdateCommentModalRef(component, marketdateComment);
            });
        } else {
            return this.marketdateCommentModalRef(component, new MarketdateComment());
        }
    }

    marketdateCommentModalRef(component: Component, marketdateComment: MarketdateComment): NgbModalRef {
        const modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static'});
        modalRef.componentInstance.marketdateComment = marketdateComment;
        modalRef.result.then((result) => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.isOpen = false;
        }, (reason) => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.isOpen = false;
        });
        return modalRef;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/marketdate-comment/marketdate-comment-popup.service.ts